/* import __COLOCATED_TEMPLATE__ from './typeform-dialog.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import TypeformManagerService, {
  TypeformModalTabType,
} from 'dashboard/services/typeform-manager';

interface TypeformDialogSignature {
  Element: HTMLDivElement;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    TypeformDialog: typeof TypeformDialog;
  }
}

export default class TypeformDialog extends Component<TypeformDialogSignature> {
  @service declare typeformManager: TypeformManagerService;

  get manager() {
    return this.typeformManager;
  }

  tabs = TypeformModalTabType;
}
